module.exports = __webpack_public_path__ + "img/puzzle-piece.2db30012.jpg";